// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"65fa31eb","453":"96dd61f8","832":"daf1e1a4"}[chunkId] + ".chunk.js";
};